import React, { useCallback } from 'react';
import { getStatusTreeData } from 'service/service';
import ComputeHierarchyBase, { FetchServiceParams } from './ComputeHierarchyBase';

const PRESERVE_FILTER_KEY = 'job_status_count_filters';

const JobStatusDetails = () => {
    const serviceFunc = useCallback((params: FetchServiceParams) => {
        return getStatusTreeData({
            startDate: params.startDate,
            endDate: params.endDate,
            env: params.env && params.env !== 'both' ? params.env : '',
            sector: params.sector && params.sector !== 'all' ? params.sector : '',
            location: params.location && params.location !== 'ALL' ? params.location : '',
            selectedDateInString: params.apiDateRangeKey,
            page: params.page,
            limit: params.pageSize,
            filters: params.filters,
        });
    }, []);

    return (
        <ComputeHierarchyBase
            serviceFunc={serviceFunc}
            pageTitle="Distinct Run Count Details"
            tableTitlePrefix="Total Distinct Run Count"
            columnLabel="Distinct Run Count"
            isCurrency={false}
            preserveFilterKey={PRESERVE_FILTER_KEY}
            detailPath="/databricksADB/statusOverview/detail_table"
            tableType="distinct-run-count-details"
            breadcrumbLabel="Job Analysis"
            breadcrumbPath="/databricksADB/jobsADB"
        />
    );
};

export default JobStatusDetails;